import { render, staticRenderFns } from "./AdminNewAdmin.vue?vue&type=template&id=ce56f2a0&scoped=true&"
import script from "./AdminNewAdmin.vue?vue&type=script&lang=js&"
export * from "./AdminNewAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AdminNewAdmin.vue?vue&type=style&index=0&id=ce56f2a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce56f2a0",
  null
  
)

export default component.exports